export default function verifyLeadingSlash (string) {
  return string.startsWith('/') ? string : `/${string}`
}



// WEBPACK FOOTER //
// ./client/util/verifyLeadingSlash.js